var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('section', {
    staticClass: "my-4 my-lg-5"
  }, [_c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "11",
      "md": "8",
      "lg": "5"
    }
  }, [_c('b-input-group', {
    staticClass: "align-items-center border border-platform rounded p-2 shadow search-input",
    style: {
      borderWidth: '4px !important',
      borderRadius: '5px'
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('b-btn', {
          attrs: {
            "variant": "text p-0"
          },
          on: {
            "click": function ($event) {
              return _vm.search(_vm.str);
            }
          }
        }, [_c('i', {
          staticClass: "icon icon-search text-24 text-platform"
        })])];
      },
      proxy: true
    }])
  }, [_c('b-form-input', {
    staticClass: "border-0 px-2 text-14 text-md-18",
    attrs: {
      "placeholder": "검색어를 입력하세요."
    },
    on: {
      "keypress": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(_vm.str);
      }
    },
    model: {
      value: _vm.str,
      callback: function ($$v) {
        _vm.str = $$v;
      },
      expression: "str"
    }
  })], 1)], 1)], 1)], 1), _c('section', [_c('middle-container', {
    staticClass: "mb-5 pb-lg-3"
  }, [_vm.pending.search ? [_c('div', {
    staticClass: "text-center p-4"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "platform"
    }
  })], 1)] : _vm.items ? [_c('section', {
    staticClass: "mt-3 mb-5"
  }, [_c('header', {
    staticClass: "mb-3 pb-3 d-lg-flex align-items-center justify-content-between border-bottom border-platform"
  }, [_c('h2', {
    staticClass: "text-13 text-md-18"
  }, [_c('strong', {
    staticClass: "fw-600"
  }, [_vm._v(_vm._s(_vm.selectedCateogry))]), _vm._v(" 키워드 \"" + _vm._s(_vm.query.query) + "\"에 대한 "), _vm.items.length ? [_vm._v(" " + _vm._s(_vm.items.length) + "개의 검색결과를 찾았습니다. ")] : !_vm.items || !_vm.items.length ? [_vm._v(" 검색결과가 없습니다. ")] : _vm._e()], 2)]), _vm.items && _vm.items.length ? [_c('b-row', {
    attrs: {
      "align-v": "start"
    }
  }, _vm._l(_vm.items, function (item, i) {
    return _c('b-col', {
      key: i,
      staticClass: "mb-3",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": _vm.listTypeColumn
      }
    }, [_c('article', {
      class: `py-3 article article-${_vm.listType} cursor-pointer`,
      on: {
        "click": function ($event) {
          return _vm.$router.push({
            path: `/process-preview`,
            query: {
              processId: item.processId,
              editorType: 'process'
            }
          });
        }
      }
    }, [_c('header', {
      staticClass: "pt-2 mb-1 d-flex algin-items-center justify-content-between"
    }, [_c('h3', {
      staticClass: "text-16 text-md-18 fw-400"
    }, [_vm._v(" [" + _vm._s(item.fieldName) + "] " + _vm._s(item.processName) + " ")])]), _c('section', {
      staticClass: "py-2"
    }, [_c('p', {
      staticClass: "m-0 p-0 text-14 text-gray-6"
    }, [_vm._v(" " + _vm._s(_vm.getDate(item.createdDate)) + " | " + _vm._s(item.userName) + " ")])]), _c('b-row', {
      staticClass: "pt-3",
      attrs: {
        "align-v": "start"
      }
    }, [_c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "cols": _vm.listType === 'list' ? 6 : 12,
        "lg": _vm.listType === 'list' ? 6 : 12,
        "order": _vm.listType === 'list' ? 0 : 0,
        "order-md": _vm.listType === 'list' ? 1 : 0
      }
    }, [_c('b-row', {
      staticClass: "mx-n1",
      attrs: {
        "align-v": "start"
      }
    }, _vm._l(_vm.process, function (p, l) {
      return _c('b-col', {
        key: l,
        staticClass: "px-1 mb-1",
        attrs: {
          "cols": "6",
          "lg": 3
        }
      }, [_c('div', {
        staticClass: "text-center d-flex align-items-center justify-content-center py-2",
        class: item[p.bind] ? 'bg-dark' : 'bg-gray-9'
      }, [_c('i', {
        class: `icon icon-platform-${p.icon} mr-2 icon-20`
      }), _c('span', {
        staticClass: "text-white text-12 text-nowrap"
      }, [_vm._v(" " + _vm._s(p.title) + " ")])])]);
    }), 1)], 1)], 1)], 1)]);
  }), 1), _c('div', {
    staticClass: "mt-5 d-flex justify-content-center"
  }, [_c('b-pagination', {
    staticClass: "platform-pagination mb-0",
    attrs: {
      "total-rows": _vm.page.totalElements,
      "per-page": _vm.page.perPage,
      "hide-goto-end-buttons": "",
      "prev-class": "prev-btn mr-2",
      "next-class": "next-btn ml-2",
      "page-class": "mx-1"
    },
    on: {
      "change": function ($event) {
        return _vm.$router.push({
          path: '/platform/search',
          query: Object.assign({}, _vm.query, {
            pageNo: $event
          })
        });
      }
    },
    scopedSlots: _vm._u([{
      key: "prev-text",
      fn: function () {
        return [_c('i', {
          staticClass: "icon icon-prev-arrow text-20 mb-n1 text-white"
        })];
      },
      proxy: true
    }, {
      key: "next-text",
      fn: function () {
        return [_c('i', {
          staticClass: "icon icon-next-arrow text-20 mb-n1 text-white"
        })];
      },
      proxy: true
    }], null, false, 3634236649),
    model: {
      value: _vm.page.pageNo,
      callback: function ($$v) {
        _vm.$set(_vm.page, "pageNo", $$v);
      },
      expression: "page.pageNo"
    }
  })], 1)] : [_c('div', {
    staticClass: "border d-flex flex-column py-5 align-items-center justify-content-center"
  }, [_c('i', {
    staticClass: "icon icon-search text-platform text-48 text-md-56s",
    style: {
      opacity: 0.4
    }
  }), _c('h1', {
    staticClass: "mt-1 text-20 text-md-24",
    style: {
      opacity: 0.4
    }
  }, [_vm._v(" No Results Found ")])])]], 2)] : !_vm.pending.search && !_vm.query.query ? void 0 : [_c('div', {
    staticClass: "my-5 py-md-5 text-center d-flex flex-column align-items-center"
  }, [_c('img', {
    style: {
      width: '96px'
    },
    attrs: {
      "src": require('@/assets/protocol/noData.svg'),
      "alt": "데이터가 없음 표시 이미지"
    }
  }), _c('h1', {
    staticClass: "mt-3 text-16 text-gray-6 lh-180"
  }, [_vm._v("권한이 없습니다")]), _c('small', [_vm._v("공정도와 프로토콜 검색에는 계정 권한이 필요합니다.")]), _c('div', {
    staticClass: "mt-4 d-flex align-items-center text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "outline-platform",
      "to": "/account/signup"
    }
  }, [_vm._v("회원가입")]), _c('span', {
    staticClass: "mx-3"
  }, [_vm._v("혹은")]), _c('b-btn', {
    attrs: {
      "variant": "platform ",
      "to": "/account/login"
    }
  }, [_vm._v("로그인")])], 1)])]], 2)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }